export default __webpack_public_path__ + "static/media/bulma_metis.394a2221.png";